/**
 * Gets the total renewal price for a subscription.
 * @param subsWithMop - The subscription with the method of payment.
 * @returns The total renewal price.
 */
export var getTotalRenewalPrice = function getTotalRenewalPrice(subsWithMop) {
  var _subsWithMop$myLatest;
  var _ref = ((_subsWithMop$myLatest = subsWithMop.myLatestSubscriptionsV1) === null || _subsWithMop$myLatest === void 0 ? void 0 : _subsWithMop$myLatest.cheggStudy) || {},
    subscription = _ref.subscription;
  if (!subscription) return 0;
  var transactions = subscription.transactions,
    subscriptionPurchaseInfo = subscription.subscriptionPurchaseInfo;
  var currencyCode = subscriptionPurchaseInfo.currencyCode,
    purchasePrice = subscriptionPurchaseInfo.purchasePrice;
  if (currencyCode === 'AUD' && (!transactions || transactions.length === 0)) {
    return Number((purchasePrice * 1.1).toFixed(2));
  } else if (transactions && transactions.length) {
    var amount = transactions[0].amount;
    return amount;
  }
  return purchasePrice;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/PRSUtils/nextInteractionUtil/getTotalRenewalPrice.js
// module id = 4162
// module chunks = 11